import { regExpNumbersAndLetters } from '@constants/regExp';

const removeSpecialSymbols = (str: string): string => {
	if (!str) return '';

	return str.replace(regExpNumbersAndLetters, '').toUpperCase();
};

export const generateLogoInitials = (initialFirst: string, initialSecond?: string): string => {
	if (!initialFirst) return '';

	const preparedInitialFirst = removeSpecialSymbols(initialFirst);
	const preparedInitialSecond = removeSpecialSymbols(initialSecond || '');

	if (preparedInitialSecond) {
		return preparedInitialFirst.charAt(0) + preparedInitialSecond.charAt(0);
	}

	return `${preparedInitialFirst.charAt(0)}${preparedInitialFirst.charAt(preparedInitialFirst.length - 1)}`;
};
